export default "__VITE_ASSET__BZHYy2P3__"